import DefaultEditor from './defaultEditor';
import SceneEditor from './sceneEditor';
import LayerEditor from './layerEditor';
import PortalWidgetEditor from './portalWidgetEditor';
import InfoWindowWidgetEditor from './infoWindowWidgetEditor';
import TextWidgetEditor from './textWidgetEditor';
import PrefabInstanceEditor from './prefabInstanceEditor';
import PrefabWidgetEditor from './prefabEditor';
import PortalMapWidgetEditor from './portalMapWidgetEditor';

export default {
  default: DefaultEditor,
  scene: SceneEditor,
  layer: LayerEditor,
  portalWidget: PortalWidgetEditor,
  textWidget: TextWidgetEditor,
  infoWindowWidget: InfoWindowWidgetEditor,
  instanceWidget: PrefabInstanceEditor,
  prefabWidget: PrefabWidgetEditor,
  portalMapWidget: PortalMapWidgetEditor,
};



// WEBPACK FOOTER //
// ./src/components/Inspector/index.js